<div class="event-ribbon">
<gen-dynamic-form class="event-ribbon-form-wrapper"
        [formData] = "data"
        [formName]="formId"
        [editMode]="true"
        [disabled]="true"
        [formVertical]="false"
        [listenToDataChange]="true"

></gen-dynamic-form>

<ng-container  *ngFor="let action of actionItems" class="event-ribbon-buttons">
        <gen-button  [type]="action?.btnType"
                     (click)="performAction(action)"
                     [iconClass]="action?.iconClass" [text]="action?.name"
                     [id] = "'#'+action?.type"
                     [ngClass]="{'.Auto_Button_primary.gen-button-element.primary__button':true}"
        ></gen-button>
</ng-container>

</div>
